import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';
import cssClasses from './ConsoleDisc.css'
import VolumeRange from '../VolumeRange/VolumeRange';
import Disc from './Disc/Disc';
import ProgressBar from '../../ProgressBar/ProgressBar'
import * as actionCreators from '../../../../store/actions/index';

class ConsoleDisc extends Component {

    render() {
        return (
            <React.Fragment>
                <Row className={cssClasses.ConsoleDisc} style={this.props.styles.flex}>
                    <Col md={2} sm={2} className={cssClasses.VolumeRangeColumn}>
                        <VolumeRange
                            volume={this.props.volume}
                            volumeChange={(val) => this.props.onVolumeChange(val, this.props.id)}
                        />
                    </Col>
                    <Col md={8} sm={8} className={cssClasses.DiscColumn}>
                        <Disc id={this.props.id}/>
                    </Col>
                    <Col md={2} sm={2} className={cssClasses.FilterColumn}>
                        {/* <Filters /> */}
                    </Col>
                </Row>
                <Row className={cssClasses.SliderControl}>
                    <Col className={cssClasses.ConsolesCol + " " + cssClasses.SliderControlCol}>
                        <ProgressBar
                            position={this.props.progressBarPosition}
                            audioLength={this.props.audioLength}
                            playingStatus={this.props.playingStatus}
                            onPlayAudio={() => this.props.onPlayAudio(this.props.id, this.props.progressBarPosition, this.props.audioLength, this.props.intervalId)}
                            onPauseAudio={() => this.props.onPauseAudio(this.props.id, this.props.progressBarPosition, this.props.intervalId)}
                            onStopAudio={() => this.props.onStopAudio(this.props.id, this.props.intervalId)}
                            onProgressBarUpdate={(val, operation) => this.props.onProgressBarUpdate(val, this.props.id, this.props.intervalId, this.props.audioLength, this.props.playingStatus, operation)}/>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }


}

const mapStateToprops = (state, ownProps) => {
    return {
        progressBarPosition: state.audios[ownProps.id].progressBarPosition,
        volume: state.audios[ownProps.id].volume,
        playingStatus: state.audios[ownProps.id].playingStatus,
        audioLength: state.audios[ownProps.id].audioLength,
        pizzicatoAudio: state.audios[ownProps.id].pizzicatoAudio,
        intervalId: state.audios[ownProps.id].intervalId

    }
}

const mapDispatchToProps = dispatch => {
    return {
        onVolumeChange: (value, index) => dispatch(actionCreators.updateVolume(value, index)),
        onPlayAudio: (index, pos, audioLength, intervalId) => dispatch(actionCreators.playAudio(index, pos, audioLength, intervalId)),
        onStopAudio: (index, intervalId) => dispatch(actionCreators.stopAudio(index, intervalId)),
        onPauseAudio: (index, pos, intervalId) => dispatch(actionCreators.pauseAudio(index, pos, intervalId)),
        onProgressBarUpdate: (value, index, intervalId, audioLength, status, operation) => dispatch(actionCreators.progressBarChangeHandler(value, index, intervalId, audioLength, status, operation))

    }
}

export default connect(mapStateToprops, mapDispatchToProps)(ConsoleDisc);